<template>
  <div id="app" style="width: 100%; height: 100vh">
    <div class="sm_titleDiv" v-if="!isMobile">
      <img
        class="logo"
        @click="showPages(1)"
        src="../static/image/logo.png"
        alt=""
      />
      <ul class="sm_ul">
        <li>
          <span
            :style="{ color: active == 1 ? 'white' : '#c5c5c5' }"
            @click="showPages(1)"
            >首页</span
          >
          <div :class="[active == 1 ? 'showBtn' : 'hide']"></div>
        </li>
        <li>
          <span
            :style="{ color: active == 2 ? 'white' : '#c5c5c5' }"
            @click="showPages(2)"
            >服务</span
          >
          <div :class="[active == 2 ? 'showBtn' : 'hide']"></div>
        </li>
        <li>
          <span
            :style="{ color: active == 3 ? 'white' : '#c5c5c5' }"
            @click="showPages(3)"
            >加盟</span
          >
          <div :class="[active == 3 ? 'showBtn' : 'hide']"></div>
        </li>
        <li>
          <span
            :style="{ color: active == 4 ? 'white' : '#c5c5c5' }"
            @click="showPages(4)"
            >我们</span
          >
          <div :class="[active == 4 ? 'showBtn' : 'hide']"></div>
        </li>
        <li class="sm_li">
          <img class="phone_logo" src="../static/image/phone-logo.png" alt="" />
          <span class="phone">18612313596</span>
        </li>
      </ul>
    </div>

    <div v-else>
      <div class="l_titleDiv" @click="show_cd = !show_cd">
        <img
          class="l_logo ml_20"
          @click="showPages(1)"
          src="../static/image/logo.png"
          alt=""
        />
        <div class="hbbDiv">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div :class="['sm_cd', show_cd ? 'sm_cdHeight' : '']">
        <div
          v-for="(item, index) in cd_List"
          :key="index"
          @click="showPages(index + 1)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div
        @click="show_cd = !show_cd"
        :class="['zzc', show_cd ? 'showZZc' : '']"
      ></div>
    </div>

    <!-- <div style="width: 100%; height: 50px"></div> -->
    <!--内容-->
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
import resize from "./minxins/resize.js";
export default {
  name: "App",
  mixins: [resize],
  data() {
    return {
      cd_List: ["首页", "服务", "加盟", "我们", "18612313596"],
      show_cd: false, //是否显示下拉菜单
      active: 1,
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    }
  },

  methods: {
    showPages(nums) {
      this.show_cd = false;
      if (nums == this.active) return;
      this.active = nums;
      if (nums == 1) {
        this.$router.push({ path: "/" });
      } else if (nums == 2) {
        this.$router.push({ path: "/page1" });
      } else if (nums == 3) {
        this.$router.push({ path: "/page2" });
      } else if (nums == 4) {
        this.$router.push({ path: "/page3" });
      }
    },
  },
};
</script>

<style lang="scss">
body {
  display: block;
  margin: 0;
  padding: 0;
}

.footer {
  position: relative;
  .ghDiv {
    position: absolute;
    left: 50%;
    z-index: 2;
    bottom: 15%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    align-items: center;
    .ghImg {
    max-width:100%;
    margin-right:10px;
    }
  }
  img {
    width: auto;
  }
}
a:hover,
a:link,
a:visited,
a:active,
a:focus {
  color: black;
  text-decoration: none;
  font-weight: 500;
  white-space: nowrap;
}
</style>

<style lang="scss" scoped>
.sm_titleDiv {
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 73px;
  background: rgba(0, 0, 0, 0.4);
  filter: alpha(opacity=50);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.logo {
  width: 67.5px;
  height: 14px;
}
.l_logo {
  width: 135px;
  height: 38px;
}
.sm_ul {
  height: 73px;
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    height: 73px;
    width: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    span {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    .showBtn {
      position: absolute;
      bottom: 0;
      z-index: 1;
      width: 30px;
      height: 2px;
      background-color: rgb(0, 0, 255);
    }
  }
  .sm_li {
    width: auto !important;
    display: flex;
    flex-direction: row !important;
    .phone_logo {
      width: 21px;
      height: 21px;
      margin-right: 10px;
    }
    .phone {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
    }
  }
}

.l_titleDiv {
  width: 100%;
  min-height: 50px;
  position: fixed;
  top: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .hbbDiv {
    margin: 10px 20px 10px 0;
    width: 30px;
    height: 25px;
    border: 1px solid white;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    span {
      width: 20px;
      height: 1px;
      display: block;
      background-color: white;
    }
  }
}
.sm_cd {
  position: fixed;
  top: 50px;
  z-index: 10;
  width: 100%;
  height: 0;
  // background: rgb(63, 61, 61);
  background: rgba(0, 0, 0, 0.4);
  transition: all 0.5s;
  overflow: hidden;
  div {
    line-height: 30px;
    margin: 0;
    width: 100%;
    height: 35px;
    border-bottom: 1px solid white;
    color: white;
    span {
      margin-left: 30px;
    }
  }
}
.zzc {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0);
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
  transition: all 0.5s;
}
.showZZc {
  z-index: 9 !important;
  height: 100% !important;
  background: rgba(0, 0, 0, 0.5) !important;
  opacity: 0.5 !important;
  filter: alpha(opacity=50) !important;
}

.sm_cdHeight {
  height: 175px !important;
}

.textSelect {
  color: white;
}

.hide {
  display: none;
}

.ml_20 {
  margin-left: 20px !important;
}
</style>


<style lang="scss" scoped>
.margin_li {
  margin: 0 38px;
}
.logo {
  width: 135px;
  height: 38px;
  margin: 11px 0 11px 0;
}
.width_100 {
  width: 100% !important;
}
.titlesDiv {
  .navbar-inverse {
    position: fixed;
    top: 0;
    z-index: 1;
    width: 100%;
    .container-fluid {
      // display: flex;
      // flex-direction: row;
      // align-items: center;
      // justify-content: space-around;
    }
    .navbar-header {
      // display:flex;
      // flex-direction:row;
      // align-items:center;
      // justify-content: space-between;
    }
  }
}

.fade-enter {
  opacity: 0;
}
.fade-leave {
  opacity: 1;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave-active {
  opacity: 0;
  /*transition:opacity .5s;*/
}
</style>
